<template>
<div class="w-100 h-100 p-relative d-flex align-items-center">
  <div class="container container-uedahiraku pt-md-6">
    <b-row>
      <b-col v-for="(exhibition, index) in exhibitions" :key="exhibition.id" md="6" :class="index<2? 'mb-md-3': '' ">
        <h4 class="h5 font-weight-bold d-md-none">{{ exhibition.title.rendered }}</h4>

        <b-row class="xs-slim-gutters">
          <b-col cols="5" md="12" lg="6">
            <div v-if="exhibition._embedded" class="exhibition-bg" :style="{backgroundImage: 'url('+ exhibition._embedded['wp:featuredmedia'][0].source_url +')'}">
            </div>
          </b-col>
          <b-col cols="7" md="12" lg="6">
            <h4 class="font-weight-bold d-none d-md-block mt-3 mt-lg-0">{{ exhibition.title.rendered }}</h4>
            <div class="form-row">
              <div class="col-12 col-md-6 col-lg-12">
                <dl class="text-12px text-md-13_5px mb-0">
                  <dt>場所</dt>
                  <dd>{{ exhibition.acf.place }}</dd>
                </dl>
              </div>
              <div class="col-12 col-md-6 col-lg-12 mb-0">
                <dl class="text-12px text-md-13_5px mb-0">
                  <dt>期間</dt>
                  <dd>{{ exhibition.acf.period }}</dd>
                </dl>
              </div>
            </div>

            <p class="text-12px text-md-13_5px">
              {{ exhibition.content.rendered }}
            </p>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- <p>全投稿数: {{ this.totalPosts }}</p>
    <p>全ページ数: {{ this.totalPages }}</p> -->
  </div><!-- /.container -->
  <h2 class="right-title futura tracking-1">EXHIBITION</h2>
  <div class="right-item">
    <div class="tategaki font-weight-bold">
      ウエダヒラクの展示について
    </div>
  </div>
</div>
</template>

<script>
import { mapActions } from 'vuex'
import isMobile from 'ismobilejs'

export default {
  props: {
    pageNo: {
      type: String,
      defalut: '1',
    }
  },
  data() {
    return {
      isMobile,
      exhibitions: [],
      totalPosts: 0,  // 全投稿数
      totalPages: 0   // 全ページ数
    }
  },
  mounted() {
    this.setPageControl({lightTheme: false, left: false, right: false, up: true, down: false})
    this.getExhibitions()
    this.setExhibitionPages(this.pageNo)
  },
  methods: {
    ...mapActions({
      setPageControl: 'doSetPageControl',
      setExhibitionPages: 'doSetExhibitionPages',
      setExhibitionMaxPages: 'doSetExhibitionMaxPages'
    }),
    async getExhibitions() {
      // スマホの場合は1回で2件表示
      let perPage = 4
      if (this.isMobile().phone) perPage = 2
      const payload = await this.axios.get(process.env.VUE_APP_API_BASE_URL + '/wp-json/wp/v2/exhibition?per_page='+ perPage +'&page='+ this.pageNo +'&_embed')
      .catch((e) => {
        console.log(e)
        this.exhibitions = []
      });
      if (payload.data) {
        // console.log(payload)
        this.totalPosts = payload.headers['x-wp-total']
        this.totalPages = payload.headers['x-wp-totalpages']
        this.setExhibitionMaxPages(parseInt(payload.headers['x-wp-totalpages']))
        this.exhibitions = payload.data
        this.setPageControl({lightTheme: false, left: false, right: false, up: true, down: this.totalPages > this.pageNo})

      } else {
        this.exhibitions = []
      }
    }
  }
}
</script>

<style lang="scss">
</style>